import React, { useEffect, useState } from 'react'
import { DownArrow, EditIcon, GraphIcon, HistoryCheckIcon, ManageUsersIcon, MasterCardIcon, PartialStatusIcon, UpArrowBlackIcon } from '../../icon';
import ButtonComponent from '../shared/button/button.component';
import { OrgAccountBilling } from '../../models/organization.model';
import { ColumnApi, GridApi, ValueGetterParams } from 'ag-grid-community';
import { emptyLabels, pageTitles, tenureTexts } from '../shared/constants';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../routes/route.path';
import GridComponent from '../shared/grid';
import { UserService } from '../../services/UserService';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors";
import { setHeaderTitle } from '../../helpers/header.helper';

interface IProps {
    AccountBillingData: OrgAccountBilling;
    PaymentMethodDetails: any;
}

const Overview = (props: IProps) => {
    const navigate = useNavigate();
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);

    const [showGrid, setShowGrid] = useState<boolean>(false);
    const [gridApi, setGridApi] = useState<GridApi>()
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)

    const PlanHistoryColoumnDefs = [
        {
            field: "id",
            headerName: "Plan Details",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return `${params.data.PlanName}`
                }
            },
            wrapText: false,
            autoHeight: false,
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "id",
            headerName: "Quantity",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return params.data.Quantity
                }
            },
            wrapText: false,
            autoHeight: false,
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "id",
            headerName: "Cost/Seat",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return params.data.IsYearPlan ? params.data.YPrice : params.data.Price
                }
            },
            valueFormatter: (params) => {
                if (params.data) {
                    return params.data.IsYearPlan ? `$${params.data.YPrice}` : `$${params.data.Price}`
                }
            },
            wrapText: false,
            autoHeight: false,
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "id",
            headerName: "Total Cost",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return params.data.Quantity * (params.data.IsYearPlan ? params.data.YPrice : params.data.Price)
                }
            },
            valueFormatter: (params: ValueGetterParams) => {
                if (params.data) {
                    return `$${params.data.Quantity * (params.data.IsYearPlan ? params.data.YPrice : params.data.Price)}`
                }
            },
            wrapText: false,
            autoHeight: false,
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
        {
            field: "id",
            headerName: "Group Credits",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data) {
                    return params.data.TotalGroupCredits
                }
            },
            wrapText: false,
            autoHeight: false,
            cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
        },
    ]

    const onGridReady = (params) => {
        setGridApi(params.api);
        setColumnApi(params.columnApi)
    }

    const getTotalCost = () => {
        const planDetails = props.AccountBillingData?.CurrentPlanDetails
        if (!!planDetails?.length) {
            let cost = 0;
            if (planDetails[0].IsYearPlan) {
                planDetails.map((x) => {
                    cost = cost + (x.Quantity * x.YPrice)
                })
            }
            else {
                planDetails.map((x) => {
                    cost = cost + (x.Quantity * x.Price)
                })
            }
            return `$${cost}`;
        }
        return ""
    }

    const goToRecharge = (IsAddonRecharge?: boolean) => {
        navigate(AppRoutes.NEW_RECHARGE, { state: { OrganizationId: UserService.getCurrentUserFromLocalStorage()?.OrgId, IsAddonRecharge: IsAddonRecharge } })
    }

    useEffect(() => {
        setHeaderTitle(pageTitles.ACCOUNT_BILLING)
        return setHeaderTitle
    }, [])


    return (
        <div className=' h-p-98 o-y-scroll'>
            <div className='w-p-96 d-flex justify-between mx-auto pt-3 pb-1'>
                {/*  in case is it mobile device use w-p-96 in place of w-p-48 */}
                <div className={`${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}  w-p-48 br-3`}>
                    <div className='d-flex justify-between w-p-96 mx-auto align-center py-2'>
                        <span className='h3-medium color-primary-accent'>Current Plan Summary</span>
                        <span className='h3-regular color-primary-light c-pointer' onClick={() => goToRecharge(true)}>+ Add Credits</span>
                    </div>
                    <div className='bb-primary-divider-4'></div>

                    <div className='d-flex justify-between w-p-96 mx-auto py-2'>
                        <div className='d-flex flex-direction w-p-60'>
                            <span className='h4-regular color-account-billing-text-gray'>
                                Seats
                            </span>
                            <span className='h3-medium color-primary-accent'>
                                {!!props.AccountBillingData?.SeatUsage?.length && props.AccountBillingData?.SeatUsage.map(x => `${x.Users.Total} ${x.SeatType}`).join(" + ")}
                            </span>
                        </div>
                        <div className='d-flex flex-direction '>
                            <span className='h4-regular color-account-billing-text-gray'>
                                Billing Cycle
                            </span>
                            <span className='h3-medium color-primary-accent'>
                                {!!props.AccountBillingData?.CurrentPlanDetails[0] ? props.AccountBillingData?.CurrentPlanDetails[0]?.IsYearPlan ? tenureTexts.ANNUAL : tenureTexts.MONTH : ""}
                            </span>
                        </div>
                        <div className='d-flex flex-direction'>
                            <span className='h4-regular color-account-billing-text-gray'>
                                Plan Cost
                            </span>
                            <span className='h3-medium color-primary-accent'>
                                {getTotalCost()}
                            </span>
                        </div>
                    </div>

                    <div className='d-flex flex-direction w-p-96 mx-auto py-2'>
                        <div className='d-flex justify-between color-account-billing-text-gray'>
                            <span className='h4-regular'>Credits Left</span>
                            {!!props.AccountBillingData?.CurrentPlanDetails?.length && <span className='h5-medium'>{`${(props.AccountBillingData?.GroupMsgCredits?.Total + props.AccountBillingData?.GroupMsgCredits?.Addons) - props.AccountBillingData?.GroupMsgCredits?.Used} / ${(props.AccountBillingData?.GroupMsgCredits?.Total + props.AccountBillingData?.GroupMsgCredits?.Addons)}`}</span>}
                        </div>
                        <div className='w-p-100 bg-color-progress-bar-bg h-3'>
                            {(props.AccountBillingData?.GroupMsgCredits?.Used / (props.AccountBillingData?.GroupMsgCredits?.Total + props.AccountBillingData?.GroupMsgCredits?.Addons)) * 100 > 1 &&
                                <div className={`w-p-${Math.floor((props.AccountBillingData?.GroupMsgCredits?.Used / (props.AccountBillingData?.GroupMsgCredits?.Total + props.AccountBillingData?.GroupMsgCredits?.Addons)) * 100)} bg-color-primary-light h-3`}></div>
                            }
                        </div>
                    </div>
                </div>
                <div className={`w-p-48  br-3 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}`}>
                    <div className={` w-p-100 brt-3 mx-auto align-center py-2  ${IsDarkMode ? "bg-color-side-bar-active-bg" : "bg-color-payment-method"}`}>
                        <span className='h3-medium color-lite-dark-white ml-2'>Payment Method</span>
                    </div>
                    <div className='w-p-100 h-20'>
                        <div className='d-flex flex-direction justify-center w-p-96 mx-auto br-2 bg-color-progress-bar-bg my-2 h-18'>
                            <div className='d-flex align-center ml-2'>
                                <MasterCardIcon />
                                <span className='h4-regular color-account-billing-text-gray ml-2'>{props.PaymentMethodDetails?.card_type}</span>
                                <span className='color-primary-accent h5-medium ml-2'>{!!props.PaymentMethodDetails?.masked_number ? `**** **** **** ${props.PaymentMethodDetails?.masked_number?.slice(12)}` : "--"}</span>
                            </div>
                            <div className='d-flex align-center mt-2 justify-between w-p-92 mx-auto h4-regular color-account-billing-text-gray'>
                                {!!props.PaymentMethodDetails?.expiry_month && <span className=''>{`Expires on ${props.PaymentMethodDetails?.expiry_month}/${props.PaymentMethodDetails?.expiry_year}`}</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className={`w-p-96  mx-auto mt-1 br-3 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}`}>
                <div className='w-p-98 d-flex justify-between align-center py-2 mx-auto'>
                    <span className='color-primary-accent h3-medium'>Next Payment</span>
                    <div className='d-flex align-center'>
                        <span className=' d-flex align-center color-account-billing-text-gray h4-regular border-primary-divider br-2 p-1 mr-2 c-pointer' onClick={() => { navigate(AppRoutes.NEW_USERS) }} >Manage Users  <ManageUsersIcon className='ml-1 w-3 h-3' /> </span>
                        <ButtonComponent ButtonLabel={'Modify Seats'} Variant={'secondary-btn-small'} OnClick={() => goToRecharge(false)} />
                    </div>
                </div>
                <div className='bb-primary-divider-4'></div>

                <div className='w-p-98 mx-auto d-flex py-2 p-relative flex-direction'>
                    <div className='d-flex'>
                        <div>
                            <div className='h5-regular color-account-billing-text-gray'>Seats</div>
                            <div className='color-primaryaccent h3-medium'>
                                {!!props.AccountBillingData?.SeatUsage?.length && props.AccountBillingData?.SeatUsage.map(x => `${x.Users.Total} ${x.SeatType}`).join(" + ")}
                            </div>
                        </div>
                        <div className='ml-10'>
                            <div className='h5-regular color-account-billing-text-gray'>Date</div>
                            <div className='color-primaryaccent h3-medium'>{props.AccountBillingData?.CurrentPlanDetails[0]?.RenewDate}</div>
                        </div>
                        <div className='ml-10'>
                            <div className='h5-regular color-account-billing-text-gray'>Plan Cost</div>
                            <div className='color-primaryaccent h3-medium'>{getTotalCost()}</div>
                        </div>
                        <div className='ml-10'>
                            <div className='h5-regular color-account-billing-text-gray'>Pool Credits</div>
                            <div className='color-primaryaccent h3-medium'>{props.AccountBillingData?.GroupMsgCredits?.Total}</div>
                        </div>
                        <div className='ml-10'>
                            <div className='h5-regular color-account-billing-text-gray'>Addon Credits</div>
                            <div className='color-primaryaccent h3-medium'>{props.AccountBillingData?.GroupMsgCredits?.Addons}</div>
                        </div>
                        <div className='ml-10'>
                            <div className='h5-regular color-account-billing-text-gray'>Total Credits</div>
                            <div className='color-primaryaccent h3-medium'>{props.AccountBillingData?.GroupMsgCredits?.Total + props.AccountBillingData?.GroupMsgCredits?.Addons}</div>
                        </div>
                    </div>
                    {showGrid && <div className={`bg-color-secondary w-p-100 h-28 mt-2`} style={{ transform: "scaleY(1)", transition: "transform 0.4s ease, opacity 0.4s ease" }}>
                        <GridComponent
                            ColumnDefs={PlanHistoryColoumnDefs}
                            RowData={props.AccountBillingData?.CurrentPlanDetails ?? []}
                            OnGridReady={onGridReady}
                            EmptyLabel={emptyLabels.USERS}
                            gridApi={gridApi}
                            IsPaginationEnabled={false}
                            LockVisible={false} />
                    </div>}

                    <div className='p-absolute bg-color-secondary br-50 box-shadow-primary-header-shadow w-4 h-4 d-flex align-center justify-center mx-auto c-pointer b-around-primary-accent-4' style={{ bottom: "-12px", left: "50%" }} onClick={() => setShowGrid(!showGrid)}>
                        {showGrid ? <UpArrowBlackIcon /> : <DownArrow />}
                    </div>
                </div>
            </div>

            <div className='w-p-96 d-flex justify-between mx-auto py-2'>
                <div className={`bg-color-secondary w-p-48 br-3 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}`}>
                    <div className='w-p-96 mx-auto d-flex justify-between align-center py-2'>
                        <span className='h3-medium color-primary-accent'>Active Users</span>
                        {/* <EditIcon /> */}
                    </div>
                    <div className='bb-primary-divider-4'></div>
                    <div className='w-p-96 mx-auto d-flex align-center py-2 flex-wrap'>
                        {props.AccountBillingData?.CurrentPlanDetails?.length && props.AccountBillingData.SeatUsage.map((x) => (!x.SeatType?.toLowerCase().includes("10dlc") &&
                            <div className='w-p-45 p-1 d-flex align-center'>
                                <span className='h5-regular color-account-billing-text-gray mr-2'>{x.SeatType}</span>
                                <span className='color-primary-accent h2-medium d-flex align-center'>{`${x.Users.Used} / ${x.Users.Total}`}{x.Users.Used === x.Users.Total ? <HistoryCheckIcon className='ml-1' /> : <PartialStatusIcon className='ml-1' />} </span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className={`bg-color-secondary w-p-48 br-3 ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"}`}>
                    <div className='w-p-96 mx-auto d-flex justify-between align-center py-2'>
                        <span className='h3-medium color-primary-accent'>Credit Usage
                            <span className='h5-medium color-account-billing-text-gray ml-1'>(Current Month)</span>
                        </span>
                        <span className='h3-regular color-primary-light c-pointer' onClick={() => goToRecharge(true)}>+ Add Credits</span>
                    </div>
                    <div className='bb-primary-divider-4'></div>
                    <div className='w-p-96 mx-auto d-flex align-center py-2'>
                        <div className='d-flex align-center w-p-45'>
                            <span className='h5-regular color-account-billing-text-gray mr-2'>Total Credits Used</span>
                            <span className='color-primary-accent h2-medium'>{props.AccountBillingData?.GroupMsgCredits?.Used ?? 0}</span>
                        </div>
                        <div className='d-flex align-center justify-flex-start w-p-45 ml-2'>
                            <span className='h5-regular color-account-billing-text-gray mr-2'>Credits left</span>
                            {!!props.AccountBillingData?.GroupMsgCredits?.Total && <span className='color-primary-accent h2-medium d-flex align-center'>{(props.AccountBillingData?.GroupMsgCredits?.Total + props.AccountBillingData?.GroupMsgCredits?.Addons) - props.AccountBillingData?.GroupMsgCredits?.Used}
                                <PartialStatusIcon className='ml-1' /> </span>}
                        </div>
                        <GraphIcon />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Overview;
